import React from "react";
import Link from "../Link";
import "./ChangePlanButton.css";
import changeLogo from "../../img/group-1000006368-black.svg"
import right2 from "../../img/right@2x.svg"

const ChangePlanButton = (props) => {
    const { className, logo } = props;

    return (
        <Link href="/changeplan">
            <div className="c-hange-plan-button-2">
                <img className="group-1000006368-1" src={`${logo || changeLogo}`}/>
                <div className="group-1000005256-1">
                    <div className={`change-plan-3 ${className || "nunito-bold-black-14px"}`}>Change Plan</div>
                    <img className="right-49" src={right2} />
                </div>
            </div>
        </Link>
    )
}

export default ChangePlanButton;